import type { TailoredCV } from './tailored-cv-api';

export const MASTER_CV_ID = 'master';

export type CvListItem = TailoredCV & {
  isMasterCv?: boolean;
  /** True for the user's main/default CV — the row lists pin to the top. */
  isMainCv?: boolean;
};

export function createMasterCvListItem(title: string): CvListItem {
  return {
    id: MASTER_CV_ID,
    userId: MASTER_CV_ID,
    title,
    summary: null,
    templateId: 'default',
    sections: [],
    isPublic: false,
    slug: null,
    createdAt: '1970-01-01T00:00:00.000Z',
    updatedAt: '1970-01-01T00:00:00.000Z',
    isMasterCv: true,
  };
}

export function isMasterCvListItem(
  cv: CvListItem | null | undefined,
): boolean {
  return cv?.isMasterCv === true || cv?.id === MASTER_CV_ID;
}

export function isMainCvListItem(
  cv: CvListItem,
  defaultCvId: string | null,
): boolean {
  return isMasterCvListItem(cv)
    ? defaultCvId == null
    : cv.id === defaultCvId;
}

export function defaultCvIdForListItem(cv: CvListItem): string | null {
  return isMasterCvListItem(cv) ? null : cv.id;
}

export function buildCvListWithMainFirst(
  cvs: readonly TailoredCV[],
  defaultCvId: string | null,
  masterTitle: string,
): CvListItem[] {
  const items: CvListItem[] = [createMasterCvListItem(masterTitle), ...cvs];
  return items
    .map((cv, index) => ({ cv, index }))
    .sort((left, right) => {
      const leftMain = isMainCvListItem(left.cv, defaultCvId);
      const rightMain = isMainCvListItem(right.cv, defaultCvId);
      if (leftMain !== rightMain) return leftMain ? -1 : 1;
      return left.index - right.index;
    })
    // Stamp the main flag so row UIs (the create-flow picker's "Default CV"
    // tag) don't have to re-derive it from defaultCvId.
    .map(({ cv }) => ({ ...cv, isMainCv: isMainCvListItem(cv, defaultCvId) }));
}
